import React from 'react';
import {lastIndexOf} from 'lodash';
import audioSvg from 'images/audio.svg';
import docSvg from 'images/doc.svg';
import spreadsheetsSvg from 'images/spreadsheets.svg';
import imgSvg from 'images/image.svg';
import videoSvg from 'images/video.svg';
import codeSvg from 'images/code.svg';
import pdfSvg from 'images/pdf.svg';
import fileSvg from 'images/file.svg';
import txtSvg from 'images/txt.svg';
import csvSvg from 'images/csv.svg';
// import pgpSvg from 'images/pgp.svg';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import {colors} from 'const';

const getIconByName = (ext: string) => {
   // console.debug('get icon for', ext);

   switch (ext) {
      case 'pdf':
         return pdfSvg;
      case 'doc':
      case 'docx':
         return docSvg;
      case 'xls':
      case 'xlsx':
         return spreadsheetsSvg;
      case 'txt':
         return txtSvg;
      case 'csv':
         return csvSvg;
      case 'mp3':
         return audioSvg;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'webp':
      case 'tiff':
         return imgSvg;

      case 'mp4':
      case 'm4v':
      case 'mov':
      case 'avi':
      case 'mkv':
      case 'webm':
      case 'wmv':
      case 'flv':
      case 'mpeg':
      case 'mpg':
      case '3gp':
         return videoSvg;

      case 'java':
      case 'js':
      case 'jar':
      case 'json':
         return codeSvg;

      // case 'pgp':
      // case 'asc':
      // case 'gpg':
      //    return pgpSvg;

      default:
         return fileSvg;
   }
};

export const FileIcon = ({
   name,
   width,
   alt = 'file icon',
}: {
   name: string;
   width: number;
   alt: string;
}) => {
   const ext = name.slice(lastIndexOf(name, '.') + 1, name.length).toLowerCase();

   switch (ext) {
      case 'pgp':
      case 'asc':
      case 'gpg':
         return <LockOutlinedIcon color="primary" />;
      case 'zip':
      case 'rar':
      case 'gz':
         return <FolderZipOutlinedIcon color="warning" />;
   }

   return <img src={getIconByName(ext)} width={width} alt={alt} aria-label={alt} />;
};
